import {
    AUTHENTICATING_SALESLOFT_REQUEST, AUTHENTICATING_SALESLOFT_SUCCEDDED, AUTHENTICATING_SALESLOFT_FAILED,
    UPDATING_SALESLOFT_REQUEST, UPDATING_SALESLOFT_SUCCEDDED, UPDATING_SALESLOFT_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  }
};

function salesloftReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_SALESLOFT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })
    case AUTHENTICATING_SALESLOFT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })
    case AUTHENTICATING_SALESLOFT_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 
    case UPDATING_SALESLOFT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_SALESLOFT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_SALESLOFT_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })  
      
    default:
      return state;
  }
}

export { salesloftReducer };